import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { User } from '@models/identity/user';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-customer-dialog-content',
  templateUrl: './create-customer-dialog-content.component.html',
  styleUrls: ['./create-customer-dialog-content.component.scss']
})
export class CreateCustomerDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateCustomerDialogContentComponent';

  @ViewChild('createCustomerComponent') createCustomerComponent;

  public inviteButtonActive: boolean = true;

  public customerId: number;

  constructor(public activeModal: NgbActiveModal, public formService: FormService, injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  newCustomerEvent(newUser: User) {
    this.inviteButtonActive = false;
   // this.openInviteSuccessDialog();
  }

  getButtonDisabled() {
    if (!this.formService.form.valid) {
      return true;
    }
    if (!this.inviteButtonActive) {
      return true;
    }
    return false;
  }

  openInviteSuccessDialog() {
    Swal.fire({
      title: $localize`:@@InviteUserSuccessHeader:Die Einladung wurde an den Benutzer versendet!`,
      text: $localize`:@@InviteUserSuccessBody:Sie können dem Benutzer ab sofort RFID-Karten zuweisen und ihn an Ladestationen autorisieren.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      if (result.isConfirmed) {
        this.activeModal.close();
        this.router.navigate(['/']);
      }
    })
  }
}
